import React from 'react';

import PropTypes from 'prop-types';

import Box from '@zenbusiness/zui/Box';
import Text from '@zenbusiness/zui/Text';

import AnimationProgress from '../AnimationProgress';
import * as Styled from './Tracker.style';

/**
 * A component for displaying progress with steps
 * @param {object} props - Component props
 * @param {string} props.title - Optional title to display
 * @param {string} props.summary - Optional subtitle to display
 * @param {string} props.status - Optional status to display
 * @param {string} props.date - Optional date to display
 * @param {number} props.currentStep - Optional current step to display
 * @param {number} props.totalSteps - Optional total steps to display
 * @returns {React.ReactElement} The Tracker component
 */
function Tracker({ title, summary, status, date, currentStep = 3, totalSteps = 10 }) {
  const progress = currentStep && totalSteps ? Math.round((currentStep / totalSteps) * 100) : 0;

  return (
    <Styled.Root>
      <Box alignItems="flex-start" display="flex" flexDirection="column">
        {title && (
          <Text fontWeight="600" size="lg">
            {title}
          </Text>
        )}
        {summary && <Text size="sm">{summary}</Text>}
      </Box>

      <Box marginTop={2}>
        <AnimationProgress color="secondary" height={10} value={progress} variant="determinate" />
      </Box>

      <Styled.StatusContainer>
        {status && (
          <Text fontWeight="600" size="md">
            {status}
          </Text>
        )}
        <Styled.StatusDateContainer>
          {date && (
            <>
              <Text size="sm">Ready on or near: </Text>
              <Text fontWeight={600} size="sm">
                {date}
              </Text>
            </>
          )}
        </Styled.StatusDateContainer>
      </Styled.StatusContainer>
    </Styled.Root>
  );
}

Tracker.propTypes = {
  title: PropTypes.string,
  summary: PropTypes.string,
  status: PropTypes.string,
  date: PropTypes.string,
  currentStep: PropTypes.number,
  totalSteps: PropTypes.number
};

export default Tracker;
